<script>
import { mapGetters } from 'vuex';

import ProductAttributesMixin from './mixins/product-attributes';
import ProductDetail from './ProductDetail.vue';
import ProductApplications from './ProductApplications.vue';
import pushNotification from '../../lib/push-notification';

export default {
  name: 'Product',
  props: ['product'],
  mixins: [ProductAttributesMixin],
  components: { ProductDetail, ProductApplications },
  data() {
    return { detailsShowed: false };
  },
  computed: {
    ...mapGetters({ compareMax: 'compare/max', compareProducts: 'compare/products' }),
    productReactivite() {
      return this.getPropertyValues('Réactivité'); // TODO: translation???
    },
    isCompared() {
      return this.compareProducts.find((p) => p.id === this.product.id);
    },
  },
  methods: {
    showProductDetails() {
      this.detailsShowed = !this.detailsShowed;
      if (this.product.variants.length === 0) {
        this.$store.dispatch('search/getProduct', this.product);
      }
    },
    moveProductToCompare(event) {
      const checkbox = event.target;
      if (checkbox.checked) {
        if (this.compareLimitReached()) {
          checkbox.checked = false;
          pushNotification('warning',
            this.$t('compare_limit_reached_title'),
            this.$t('compare_limit_reached', { max: this.compareMax }));
        } else {
          this.$store.dispatch('compare/addProduct', this.product);
        }
      } else {
        this.$store.dispatch('compare/deleteProduct', this.product);
      }
    },
    compareLimitReached() {
      return this.compareProducts.length >= this.compareMax;
    },
  },
};
</script>

<template>
  <tr v-if="detailsShowed" class="text-sm">
    <td colspan="4">
      <div class="flex flex-col">
        <table class="w-full table-fixed">
          <tr>
            <td class="w-1/2 md:w-4/12 p-2 md:p-3">
              <a @click.prevent="showProductDetails" href="#" class="text-blue-diagomics-dark">
                {{ productName }}</a>
            </td>
            <td class="w-1/4 md:w-3/12 p-2 md:p-3">
              <ProductApplications :product="product"></ProductApplications>
            </td>
            <td class="w-1/4 md:w-3/12 p-2 md:p-3">{{ productReactivite }}</td>
            <td class="w-hidden md:w-2/12"></td>
          </tr>
        </table>
        <ProductDetail
          :product="product"
          :productName="productName"
          @on-close="showProductDetails"
        />
      </div>
    </td>
  </tr>
  <tr v-else>
    <td class="p-2 md:p-3">
      <a @click.prevent="showProductDetails" href="#" class="text-blue-diagomics-dark">
      {{ productName }}</a>
    </td>
    <td class="p-2 md:p-3">
      <ProductApplications :product="product"></ProductApplications>
    </td>
    <td class="p-2 md:p-3">{{ productReactivite }}</td>
    <td class="hidden md:table-cell p-3 text-right relative">
      <div>
        <input @click="moveProductToCompare" type="checkbox"  :checked="isCompared"/>
      </div>
    </td>
  </tr>
</template>
